<template>
  <div>
    <input
      v-for="(item, key) in items"
      :key="key"
      type="text"
      :name="key"
      :value="item">
  </div>
</template>

<script>

export default {

  props: {
    items: {
      type: Object,
      default: null,
      required: true,
    },
  },
};
</script>

<style lang="css" scoped>
</style>
